module.exports = __webpack_public_path__ + "img/premiation-13-maleta-1-milhao.d3becbf1.png";